import { TranslatedText, Translation } from './translated-text';

export class Upsell {
  id: string;
  upsellId: string;
  name: TranslatedText;
  conditions: any[];
  products: any[];
  categories: any[];
  lastUpdated: Date;
  filterId?: string;

  constructor(
    formattedId: string,
    upsellId: string,
    name: string,
    products: any[],
    filterId?: string,
    translations?: Translation[],
  ) {
    this.id = formattedId;
    this.upsellId = upsellId;
    this.name = new TranslatedText(name);
    this.conditions = [];
    this.products = products;
    this.categories = [];
    this.lastUpdated = new Date();

    this.filterId = '';

    if (filterId) {
      this.filterId = filterId;
    }

    translations?.forEach(
      translation =>
        translation && this.name?.addTranslation(translation.language, translation.text),
    );
  }

  toGenericObject() {
    return JSON.parse(JSON.stringify(this));
  }
}
